// @module C3.ShoppingExtensions.InventoryList
define('C3.ShoppingExtensions.PDP.AddToWishlist.View'
,   [
         'c3_addtowishlist_custom.tpl',
        'Profile.Model',
        'C3.ShoppingExtensions.LoginRegister.View',
        'Utils',
        'Header.Menu.MyAccount.View',
        'Header.Menu.View',
        'C3.ShoppingExtensions.PDP.AddToWishlist.Rightside.View',
        'jQuery.sidebarPDPWishListMenu',
        'SC.Configuration',
        'UrlHelper'
    ]
, function (
        c3_addtowishlist_custom_tpl,
        ProfileModel,
        LoginRegisterView,
        Utils,
        HeaderMenuMyAccountView,
        HeaderMenuView,
        AddToWishlistRightSideView,
        _jQuerySidebarPDPWishListMenu,
        Configuration,
        UrlHelper
)
{
    'use strict';

    // @class C3.ShoppingExtensions.InventoryList.View @extends Backbone.View
    return Backbone.View.extend({

        template: c3_addtowishlist_custom_tpl

    ,   initialize: function (options) {
            this.options = options;
            this.application = options.application;
            this.item = options.item;
            this.origin = options.origin;
            this.countedClicks = {};

            const self = this;

            this.first_time_render = true;

            this.utils =
                this.application.ProductListModule && this.application.ProductListModule.Utils;
            this.collection = this.utils.getProductLists();

            ProfileModel.getPromise().done(function() {
                self.loaded_site_settings = true;
                self.render();
            });
        }

    ,   events: {
           'click [data-action="show-productlist-control"]':'showRightSideMenu',
            'click [data-action="header-sidebar-hide"]': 'hideSidebar',
            'click [data-action="hide-rightside-wishlist"]': 'hideSidebar',
            'click [data-type="header-sidebar-menu-mobile"]': 'hideSidebar',
            'click [data-action="show-login-register-popup"]': 'showLoginRegisterPopup'
        }

    ,   bindings: {
        }

    ,   childViews: {
            'AddToWishlist.RightSide': function ()
                {
                    //console.log(this)
                    var header_view_options = _.extend(
                        {
                            application: this.application,
                            item: this.item,
                            //parentView : this
                        },
                        {}
                    );
                    return new AddToWishlistRightSideView(header_view_options);
                }
        }

    ,   showRightSideMenu : function showRightSideMenu () {
            
            //Hide Offers Right Side bar
            jQuery('.main').removeClass('offers-rightside-bar-opened');
            jQuery('.offers-sidebar-close-rightside-bar').hide();
            jQuery('.offers-sidebar-overlay-sec').hide();
            jQuery('.offers-secondary-wrapper-sec').hide();
            //Hide Offers Right Side bar

            jQuery('html').css('background','none');
            jQuery('.main').addClass('wishlist-rightside-bar-opened');
            jQuery('.sidebar-close-rightside-bar').show();
            jQuery('.wishlist-secondary-wrapper-sec').show();
            jQuery('.header-secondary-wrapper-mobile').hide();
            jQuery('.shopping-layout-header').css("box-shadow","none")
            jQuery('.wishlist-sidebar-overlay-sec').show();
            
            jQuery('.shopping-layout-header').removeClass('shopping-layout-header-no-hamburger-scroll')
            jQuery('.myaccount-layout-header').removeClass('myaccount-layout-header-no-hamburger-scroll')
        }

    ,   hideSidebar : function hideSidebar(e) {
            var dontCloseFlag = false;

            if (e.target.tagName === 'A') {
                if (this.activeLink) {
                    this.activeLink.removeClass('active');
                }
                this.activeLink = jQuery(e.target);
                this.activeLink.addClass('active');
            }else if(e.target.tagName === 'SPAN')
            {
                dontCloseFlag = true;
            } 

            if(dontCloseFlag == false)
            {
            jQuery('.main').removeClass('wishlist-rightside-bar-opened');
            jQuery('.sidebar-close-rightside-bar').hide();

            jQuery('.header-secondary-wrapper-mobile').show();

            jQuery('.shopping-layout-header').css("box-shadow","rgb(153, 153, 153) 0px 1px 10px")

            jQuery('.wishlist-sidebar-overlay-sec').hide();
            
            $('.product-details-full-actions-addtowishlist .wishlist-title h1').text('Add to your Wish List');
            $('.product-details-full-actions-addtowishlist .create-new-wishlist').show();
            $('.product-details-full-actions-addtowishlist .product-list-control-new-item-add-new-list-form').hide()

            //jQuery('.header-sidebar-relatedcategories-overlay-mobile').show();

            jQuery('.shopping-layout-header').addClass('shopping-layout-header-no-hamburger-scroll')
            jQuery('.myaccount-layout-header').addClass('myaccount-layout-header-no-hamburger-scroll')
            }
    }

    ,   showLoginRegisterPopup : function showLoginRegisterPopup(e) {
                e.stopPropagation();
                e.preventDefault();
                
                var $target = jQuery(e.currentTarget);
                var origin = $target.attr('data-origin');
                
                // Check if this is for "Add to Quote" - update URL and show popup
                if (origin === 'quote') {
                    // Handle both hash-based (local) and pushState (live) routing
                    var currentUrl;
                    if (window.location.hash) {
                        // Hash-based routing (local): #product-url?params
                        currentUrl = window.location.hash.substring(1); // remove the #
                    } else {
                        // pushState routing (live): /product-url?params
                        currentUrl = window.location.pathname.substring(1) + window.location.search;
                    }
                    
                    // Append addtoquote=T to existing params
                    var returnUrl;
                    if (currentUrl.indexOf('?') > -1) {
                        returnUrl = currentUrl + '&addtoquote=T';
                    } else {
                        returnUrl = currentUrl + '?addtoquote=T';
                    }
                    
                    // Update URL silently without triggering navigation
                    Backbone.history.navigate(returnUrl, { trigger: false });
                }
                
                // Show login modal
                var Layout = this.application.getComponent('Layout');
                //console.log(Layout)

                var view = new LoginRegisterView({
                    application: Layout.application
                });

                if (view)
                Layout.showContent(view, {showInModal: true});
            }


    ,   render: function() {
            if (this.loaded_site_settings && this.utils && this.utils.isProductListEnabled()) {
                if (this.first_time_render) {
                    this.utils.getProductListsPromise().done(_.bind(this.render, this));
                    this.first_time_render = false;
                    return this.$el.empty();
                }
            } else {
                return this.$el.empty();
            }

            this._render();
        }   

        //@method getContext @return C3.ShoppingExtensions.InventoryList.View.Context
    ,   getContext: function getContext()
        {

             var product_list_mod = []
             var product_list_mod2 = []
             var product_list_items_mod = []
             var itemExistsInFavourites= false;

             var item_internalid = this.item.internalid;

             //console.log(item_internalid)

             if(this.collection)
                {
                    var plCollection = this.collection
                    ,   plCollectionModels = plCollection.models
                    ,   mainPLCollectionArray = []

                    mainPLCollectionArray = _.flatten(_.map(plCollectionModels, function(mod) {
                        var its = mod.get('items')
                        ,   its_model = its.models
                        return its_model
                    }));
                
                    var foundIt = mainPLCollectionArray.find(function(pl_line) {
                        var im = pl_line.get('item')

                        return im.get('internalid') == item_internalid
                    });
                    if(foundIt)
                      itemExistsInFavourites = true;  
                }

            var Configuration = this.application.Configuration

            var profile = ProfileModel.getInstance()
            ,   is_loading = !Configuration.get('performance.waitForUserProfile', true) && ProfileModel.getPromise().state() !== 'resolved'
            ,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'
            
            //console.log(itemExistsInFavourites)
            return {
                isLoggedIn : !is_loading && is_logged_in,
                isPhoneDevice: Utils.isPhoneDevice(),
                itemExistsInFavourites : itemExistsInFavourites,
                isLoading: this.utils.getProductListsPromise().state() === 'pending',
                SerialLotOrigin : this.origin === 'seriallot' ? true : false
            };
        }
    });
});
